import { VendorHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/vendor-handler';
import { map } from 'lodash-es';
import {
  IOAuthDetails,
  IVendorConnectConfirmation,
  IVendorConnectInitRequest,
  IVendorConnectInitResponse
} from '@portal/app/dashboard/integrations/models/vendor/VendorIntegrationModels';
import { IVendorInitiateRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorInitiateRequest';
import {
  callbackDomain,
  VendorIdSource
} from '@portal/app/dashboard/integrations/shared/constants';
import { IVendorConfigurationRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorConfigurationRequest';
import { IVendorOAuthConfirmationRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorOAuthConfirmationRequest';
import { StorageService } from '@portal/app/shared/services/storage.service';
import { IVendorReConfigurationRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorReConfigurationRequest';
import { WindowService } from '@portal/app/shared/services/window.service';

export class AdwordsHandler implements VendorHandler {
  constructor(
    private storageService: StorageService,
    private windowService: WindowService
  ) {}

  prepareRequestObjectToInitiateVendor(
    vendorDetails: IVendorConnectInitRequest
  ): IVendorInitiateRequest {
    /* eslint-disable no-console */
    console.log(`Adwords initiation data: ${vendorDetails}`);
    return {
      req: {},
      queryParams: { callbackDomain: callbackDomain() },
      pathParams: { vendorId: VendorIdSource.adwords }
    };
  }

  prepareRequestObjectToConfigureVendor(
    accounts: {
      accountName: string;
      accountId: string;
      clientAccountName?: string;
      managerId?: string;
      disabled: boolean;
    }[]
  ): IVendorConfigurationRequest {
    return {
      vendorId: VendorIdSource.adwords,
      vendorData: map(accounts, (account) => ({
        clientAccountId: account.accountId,
        managerId: account.managerId,
        clientAccountName: account.clientAccountName
      }))
    };
  }

  handleVendorInitiateResponse(data: IVendorConnectInitResponse): void {
    localStorage.setItem(
      'callBackParams',
      JSON.stringify(
        (data.vendorCredentialsDetails as IOAuthDetails).callbackParameters
      )
    );
    this.windowService.navigateToHref(
      (data.vendorCredentialsDetails as IOAuthDetails).redirectURL
    );
  }

  confirmVendor(data: IVendorConnectConfirmation): void {
    const jsonData = data.accountDetails
      ? JSON.stringify(data.accountDetails.vendorAccounts)
      : '';
    this.storageService.setIntegrationAccountDetails(
      VendorIdSource.adwords,
      jsonData
    );
  }

  prepareRequestToConfirmVendor(): IVendorOAuthConfirmationRequest {
    return {
      code: `${localStorage.getItem('code')}`,
      state: `${localStorage.getItem('state')}`,
      callbackDomain: callbackDomain()
    };
  }

  prepareRequestObjectToReConfigureVendor(
    accounts: {
      accountName: string;
      accountId: string;
      managerId?: string | undefined;
      disabled: boolean;
    }[],
    dsInstanceIds: number[]
  ): IVendorReConfigurationRequest {
    return {
      vendorId: VendorIdSource.adwords,
      vendorData: map(accounts, (account) => ({
        clientAccountId: account.accountId,
        managerId: account.managerId
      })),
      dsInstanceIds
    };
  }
}
